module.exports = __webpack_public_path__ + "static/media/02_Special_Ep5.0f0a3d65.jpg";